<section class="gallery">

    <img class="bio-photo" src="https://res.cloudinary.com/dadqp2oia/image/upload/v1629671570/Music%20Website/Apparition-coneyIsland-about-lowRes_qwxcfa.png" alt="Elyza at Coney Island with Guitar">

</section>

